import clsx from "clsx";
import React from "react";

type BuildersLogoProps = React.ImgHTMLAttributes<HTMLImageElement> & {
  className?: string;
};

export default function BuildersLogo({
  className = "",
  ...rest
}: BuildersLogoProps) {
  return (
    <img
      className={clsx("tw-h-14 tw-w-18", className)}
      id="moving-image"
      src="/builderslogo.png"
      alt="Builders Logo"
      {...rest}
    />
  );
}
